
import { groupBy } from 'lodash';
import { OrderProduct } from '../types/types';

/**
 * 에스크로 결제를 위한 상품 정보 생성
 * @param products
 * @param orderNumber
 * @returns input name=good_info 에 대한 value
 */
export default function makeKCPGoodInfo (products: OrderProduct[], orderNumber: string) {
  const chr30 = String.fromCharCode(30);
  const chr31 = String.fromCharCode(31);

  if (!products || !products.length) return '';

  const goodInfo = products
    .map((product, idx) => {
      return (
        `seq=${idx + 1}` +
        chr31 +
        `ordr_numb=${orderNumber}` +
        chr31 +
        `good_name=${product.productName}` +
        chr31 +
        `good_cntx=1` +
        chr31 +
        `good_amtx=${product.unitPrice}`
      )
    })
    .join(chr30);

  return goodInfo;
}
